import { reportInventoryStockTypes } from "./types";
import { newDate } from "helpers/dateTools";

const {
  SET_INVENTORY_STOCK_FILTERS,
  RESTORE_INITIAL
} = reportInventoryStockTypes;

const initialState = {
  startDate: newDate(),
  endDate: newDate(),
  station: null,
};

export const reportInventoryStockReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_INVENTORY_STOCK_FILTERS:
      return { ...state, [payload.key]: payload.value };

    case RESTORE_INITIAL:
      return initialState;

    default:
      return state;
  }
};
